import { ChangeDetectionStrategy, Component, computed, effect, inject, INJECTOR, input, signal, type OnInit } from '@angular/core';
import type { FieldTree } from '@angular/forms/signals';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CSCApi } from '../../api/csc.api';
import { dropdownIndicator } from '../../custom-icons';
import { FORM_IMPORTS } from '../../forms/form-imports';
import { ImportsModule } from '../imports.module';
import { filterCountryCode, getPhoneCodeOptions, type PhoneNumberWithCode } from '../phone-code';

@Component({
  selector: 'phone-number-input',
  templateUrl: './phone-number-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImportsModule,
    FORM_IMPORTS,
    MatAutocompleteModule,
  ],
  host: {
    class: 'flex gap-2 justify-start'
  }
})
export class PhoneNumberInputComponent implements OnInit {
  private readonly injector = inject(INJECTOR);
  private readonly api = {
    csc: inject(CSCApi)
  } as const;

  protected readonly icons = {
    dropdownIndicator
  } as const;

  public readonly controls = input.required<FieldTree<PhoneNumberWithCode>>();

  private readonly allCountries = this.api.csc.countries();

  protected isdCode = (() => {
    const options = computed(() => getPhoneCodeOptions(this.allCountries.value()));

    const query = signal('');
    const filtered = filterCountryCode(options, query);

    return {
      query,
      filtered
    } as const;
  })();

  ngOnInit() {
    effect(() => {
      const value = this.controls().code().value();
      this.isdCode.query.set(value);
    }, { injector: this.injector });
  }
}
